/**
 * @typedef {({
 *     selector: {
 *         attribute: string;
 *         value: string;
 *     };
 *     condition_type: '=='|'!=';
 *     lookup: {
 *         attribute: string;
 *         value: string;
 *     }
 * })} ParsedGroupData
 */

/**
 * Parse elements `data-show-if` attribute into object
 * @param groupElement
 * @returns {ParsedGroupData}
 */
function parseConditionalGroup(groupElement) {
	try {
		const showIfRaw = groupElement.dataset?.showIf;
		if (!showIfRaw) {
			throw new Error(`Group doesn't have data-show-if attribute`);
		}

		return JSON.parse(showIfRaw);

	} catch (err) {
		console.error('Conditional parsing error:', err);
	}
}

function parseConditional(entry, form) {
	const { selector, condition_type, lookup } = entry;
	const buildedSelector = `[${selector.attribute}="${selector.value}"]`;
	const element = form.querySelector(buildedSelector);
	if (!element) {
		console.error(`Couldn't find a ${buildedSelector} selector`)
		return false;
	}

	const lookupAttribute = lookup.attribute;
	const lookupValue = lookup.value;

	let elementValue;
	if (lookupAttribute === 'checked') {
		elementValue = element.checked ? 'checked' : '';
	} else if (lookupAttribute === 'value') {
		elementValue = element.value;
	} else {
		elementValue = element.getAttribute(lookupAttribute)
	}

	return {
		element,
		elementValue,
		condition_type,
		lookupAttribute,
		lookupValue,
	}
}

function getGroupSelectors(entries, form) {
	return entries.reduce((collection, entry) => {
		const isGroup = Reflect.has(entry, 'group');

		if (isGroup) {
			return [...collection, ...getGroupSelectors(entry.group, form)];
		} else {
			const { element } = parseConditional(entry, form);
			return [...collection, element];
		}
	}, []);
}

function checkParsedGroup(entries, form) {
	return entries.every((entry) => {
		let collection = [];
		const operator = entry?.operator ?? '&&';
		const isGroup = Reflect.has(entry, 'group');

		if (isGroup) {
			collection = [...collection, checkParsedGroup(entry.group, form)];
		} else {
			const { condition_type, lookupValue, elementValue } = parseConditional(entry, form);

			collection.push(
				(condition_type === '==' && lookupValue === elementValue) ||
				(condition_type === '!=' && lookupValue !== elementValue)
			);
		}

		return operator === "||" ? collection.some((el) => el) : collection.every((el) => el);
	});
}
